module.exports = __webpack_public_path__ + "img/list_Story_11.832c4816.jpeg";